<template>
    <rkm-modal
        hide-header
        large
        ref="Modal"
        title="Confirmação"
    >
        <h5 class="text-primary">
            Confirmação
        </h5>

        <p class="m-0">
            <rkm-alert
                color="info"
                class="mt-4 mb-3"
            >
                Confirmar procedimento já realizado: Use quando o paciente chega com exames/procedimentos cumpridos.
                Isso evita duplicidade e marca a etapa como cumprida no protocolo.
            </rkm-alert>

            Deseja confirmar algum procedimento como já realizado?
        </p>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Não
            </rkm-button>

            <rkm-button
                color="primary"
                @click="confirm"
            >
                Sim
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    methods: {
        open() {
            this.$refs.Modal.show()
        },
        confirm() {
            this.$emit('confirm')
            this.$refs.Modal.hide()
        }
    }
}
</script>